import { useTranslation } from 'react-i18next';

function triggerAIAgent() {
  const btn = document.querySelector<HTMLButtonElement>('#vapi-widget-floating-button');
  if (btn) btn.click();
}

export default function LeadCTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20textile%20fabric%20threads%20and%20looms%20close-up%20photography%2C%20golden%20amber%20and%20cream%20colors%2C%20intricate%20woven%20texture%20patterns%2C%20soft%20shallow%20depth%20of%20field%2C%20artistic%20industrial%20textile%20aesthetic%2C%20warm%20natural%20lighting%2C%20rich%20organic%20textures%2C%20luxurious%20fabric%20detail&width=1800&height=900&seq=cta-bg-textile&orientation=landscape"
          alt="Textile manufacturing background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/45 to-foreground-950/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-16 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-background-50 tracking-tight leading-tight mb-4 md:mb-6">
          {t('cta.title')}
        </h2>

        <p className="text-sm md:text-base text-background-50/75 max-w-xl mx-auto leading-relaxed mb-8 md:mb-10">
          {t('cta.subtitle_line1')}
          <br />
          {t('cta.subtitle_line2')}
        </p>

        {/* AI Chat Button — triggers Readdy Agent */}
        <button
          onClick={triggerAIAgent}
          className="group inline-flex items-center gap-0 bg-foreground-950 text-background-50 rounded-full overflow-hidden hover:bg-foreground-900 transition-colors duration-300 cursor-pointer"
        >
          <span className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-accent-500 rounded-full shrink-0">
            <i className="ri-robot-2-line text-lg md:text-xl text-background-50"></i>
          </span>
          <span className="px-5 md:px-6 text-sm md:text-base font-semibold whitespace-nowrap">
            {t('cta.button')}
          </span>
          <span className="pr-5 md:pr-6">
            <i className="ri-arrow-right-up-line text-lg text-background-50/60 group-hover:text-background-50 transition-colors duration-200"></i>
          </span>
        </button>
      </div>
    </section>
  );
}